export default {
  en: {
    fetchError: 'Failed fetching client notes.',
    fetchRetry: 'Retry',
    emptyNotePlaceholder: 'Leave a note...',
    contentRequired: 'Enter a note',
    add: 'Add note',
    added: 'Note added',
    addError: 'Failed to add note. Please try again.',
    maxLengthError: 'Note is too long!',
    attachmentsUploading: 'Wait for your attachments to finish uploading',
    save: 'Save',
    saved: 'Note saved',
    saveError: 'Failed to save note. Please try again.',
    cancel: 'Cancel',
    visibleLabel: 'Private notes are only visible to {0}.',
    pinTooltip: 'Pin note',
    unpinTooltip: 'Unpin note',
    editTooltip: 'Edit note',
    pinFailed: 'Failed to pin note.',
    pinned: 'Note pinned',
    unpinned: 'Note unpinned',
    pinnedLabel: 'Pinned',
    unpinFailed: 'Failed to unpin note.',
    deleteTooltip: 'Delete note',
    deleteFailed: 'Failed to delete note.',
    deleted: 'Note deleted',
    emptyPlaceholder: 'No notes yet on this supplier, create one above.',
    deleteConfirmTitle: 'Are you sure you want to delete this note?',
    deleteConfirmDescription: 'This action cannot be undone.',
  },
};
